import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { IBroker } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";

export interface IExtraData {
  property: IProperty;
  applications: IApplication[];
  user: IUser;
  // The authenticated broker (from useSelf) — reliably includes `features`,
  // unlike the broker embedded on an application, which is not fetched with
  // its features and would make the RentMatch booking URL fall back to the
  // mijnhuurprofiel domain.
  broker?: IBroker;
  localeMessages: { [key: string]: string | undefined };
}

export enum EField {
  TenantFeedbackText = "tenantFeedbackText",
}
